export const PDF_SERVICE_I18N = {
  report: {
    outputDate: $localize`:@@data.util.pdf.report.outputDate:出力日 `,
    title: $localize`:@@data.util.pdf.report.title:摂食嚥下機能報告書`,
    chartNumber: $localize`:@@data.util.pdf.report.chartNumber:カルテ番号`,
    patientName: $localize`:@@data.util.pdf.report.patientName:患者氏名`,
    evaluationDate: $localize`:@@data.util.pdf.report.evaluationDate:評価日`,
    birthDate: $localize`:@@data.util.pdf.report.birthDate:生年月日`,
    age: $localize`:@@data.util.pdf.report.age:年齢`,
    ageUnit: $localize`:@@data.util.pdf.report.ageUnit:歳`,
    sex: $localize`:@@data.util.pdf.report.sex:性別`,
    signature: $localize`:@@data.util.pdf.report.signature:担当者署名`,
  },
} as const;
